export default __webpack_public_path__ + "static/mefa-shop_1_1_de-312ddfc8ba5a1962abc59f117afd7b07.png";